import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import LanguageSelector from "../components/LanguageSelector";

export default function Forgot() {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");
    const [link, setLink] = useState("");
    const submit = async (e) => {
        e.preventDefault();
        setMsg(""); setErr(""); setLink("");
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setMsg(data.message);
            if (data.dev_reset_link) setLink(data.dev_reset_link);
        } catch (er) {
            setErr(formatErr(er.response?.data?.detail) || er.message);
        }
    };
    return (
        <div className="min-h-screen grain grid place-items-center p-6" data-testid="forgot-page">
            <form onSubmit={submit} className="w-full max-w-sm card-warm p-7 fade-up">
                <div className="flex items-start justify-between gap-3 mb-1">
                    <div className="font-serif text-2xl">{t("auth.resetTitle")}</div>
                    <LanguageSelector compact testid="forgot-language-selector" />
                </div>
                <div className="text-sm text-[var(--text-ink)]/65 mb-5">{t("auth.resetSent")}</div>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                       placeholder={t("auth.email")} data-testid="forgot-email"
                       className="w-full px-3 py-2 rounded-xl border border-[rgba(26,19,24,0.15)] focus:outline-none focus:border-[var(--brand-purple)]" />
                <button type="submit" data-testid="forgot-submit-btn" className="btn-primary w-full mt-4">{t("auth.sendReset")}</button>
                {msg && <div className="text-sm text-[var(--status-green)] mt-3" data-testid="forgot-success">{msg}</div>}
                {link && (
                    <div className="mt-2 text-xs break-all">
                        Dev link: <a href={link} className="text-[var(--brand-purple)] underline" data-testid="forgot-dev-link">{link}</a>
                    </div>
                )}
                {err && <div className="text-sm text-[var(--status-red)] mt-3">{err}</div>}
                <Link to="/login" className="block text-sm text-center mt-4 text-[var(--text-ink)]/70 hover:underline">{t("common.back")}</Link>
            </form>
        </div>
    );
}
